module.exports = __webpack_public_path__ + "static/expensebook-0fd2f68c13facd23848187ecd0e88352.png";